import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const DashboardIcon: React.FC<CardGradientProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="6"
        height="6"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="2"
        y="12"
        width="6"
        height="6"
        rx="3"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="12"
        y="2"
        width="6"
        height="6"
        rx="3"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="12"
        y="12"
        width="6"
        height="6"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
